import { gql } from '@apollo/client';

export const GET_VIEW_URL = gql`
  mutation GetViewURL($key: String!) {
    getViewURL(key: $key) {
      success
      message
      viewURL
    }
  }
`;